import React from 'react';
import { Flex, Space, Typography } from 'antd';
import { ArrowRightOutlined, EditFilled, PlusOutlined, StopOutlined } from '@ant-design/icons';
import Balance from '../Balance/Balance';
import CardsBlock from '../Cards/Cards';
import OtherBlock from '../Other/Other';
import RequisitesBlock from '../Requisites/Requisites';
import classes from './AccountLayout.module.css';
import { useIntl } from 'react-intl';
import { Card, CType, CStatus } from 'entities/card/model/types';
import { ActionButton, BackButton, GridContainer, RoundContainer } from 'shared/ui';
import { AccStatus } from 'entities/account/model/types';
import Transactions from '../../../../widgets/transactions/ui/Transactions';
import { ChangeAccountName } from 'features/account/change-account-name';
import { GetCards } from '../GetCards/GetCards';

type AccountLayoutProps = {
  color: string;
  title: string;
  balance: number;
  card?: Card;
  iban: string;
  status?: string | null;
  canAddCard?: boolean;
  onTopup: () => unknown;
  onStatementDownload?: ({
    dateRange,
    format,
    id
  }: {
    dateRange: Array<string>;
    format: 'pdf' | 'csv';
    id?: number | string;
  }) => Promise<any> | void;
};

const AccountLayout: React.FC<AccountLayoutProps> = ({
  title,
  color,
  balance = 0,
  status,
  iban,
  card,
  canAddCard = false,
  onTopup,
  onStatementDownload
}) => {
  const { formatMessage: t } = useIntl();

  return (
    <>
      <GridContainer
        rowProps={{
          style: {
            background: color,
            paddingBottom: 32
          }
        }}
      >
        <BackButton />
        <Space className={classes.fullWidth} direction='vertical' size={24}>
          <Space className={classes.fullWidth} direction='vertical' size={4}>
            {status === AccStatus.Closed && (
              <Flex gap={8} align='center' style={{ marginBottom: 20 }}>
                <StopOutlined style={{ fontSize: 16 }} />
                <Typography.Text style={{ fontWeight: 600, fontSize: 18 }}>
                  {t({ id: 'river.views.accountStatusPage.closed.title' })}
                </Typography.Text>
              </Flex>
            )}
            <Space size={8}>
              <Typography.Text className={classes.title}>{title}</Typography.Text>
              <ChangeAccountName />
            </Space>
            <Balance balance={balance} />
          </Space>
          <Flex gap={8}>
            <ActionButton
              text={t({ id: 'buttons.topup' })}
              icon={<PlusOutlined style={{ fontSize: 24 }} />}
              onClick={onTopup}
              id='btn__load'
            />
          </Flex>
        </Space>
      </GridContainer>
      <GridContainer
        rowProps={{
          style: {
            marginTop: 32
          }
        }}
      >
        <Space className={classes.fullWidth} direction='vertical' size={20}>
          {canAddCard && <GetCards />}
          <Transactions />
          {card && card.status !== CStatus.Closed && <CardsBlock card={card} />}
          <OtherBlock onStatementDownload={onStatementDownload} />
        </Space>
      </GridContainer>
    </>
  );
};

export default AccountLayout;
